import React from 'react'
import ReactDOM from 'react-dom'
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const useStyles = makeStyles(styles);

export function Modal (props) {
    const classes = useStyles();

    if (!props.isOpen) {
        return null
    }
    const ref = React.createRef();

    function getTitleDialog () {
        if (props.titleModal) {
            return  <DialogTitle id="max-width-dialog-title">
                        <Typography variant="h6">
                            {props.titleModal}
                        </Typography>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={props.onClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
        }
    }

    return ReactDOM.createPortal(
    <Dialog
        fullWidth={true}
        maxWidth={props.maxWidth}
        open={props.isOpen}
        onClose = {props.onClose}
        aria-labelledby="max-width-dialog-title"
      >
        {
            getTitleDialog()
        }
        <DialogContent dividers={props.scroll}>
        <DialogContentText>
            {
                props.children
            }
        </DialogContentText>
        </DialogContent>
        {
            props.actionsFooter && 
            <DialogActions>
                {
                    props.handleCancel && <Button variant="contained" size="small" color="default" startIcon={<ClearIcon />} onClick={props.handleCancel}>No</Button>
                }
                {
                    props.handleConfirm && <Button variant="contained" size="small" color="primary" startIcon={<CheckIcon />} onClick={props.handleConfirm}>Si</Button>
                }
                {
                    props.handleClose && <Button variant="contained" size="medium" color="default" onClick={props.handleClose}>Cerrar</Button> 
                }
                {
                    props.handlePrint && <Button variant="contained" size="medium" color="primary" onClick={props.handlePrint}>Imprimir</Button> 
                }
            </DialogActions>
        }
    </Dialog>,
    document.getElementById('modal'))
}